class ObfuscateEntry {
    regex: RegExp;
    replace: string;
    constructor(regex: RegExp, replace: string) {
        this.regex = regex;
        this.replace = replace;
    }
}

export class VersionObfuscator {
    static readonly obfuscateMap = [
        // BV5000 firmware
        new ObfuscateEntry(/(?<major>\d{3})-(?<minor>\d{2})(?<build>[A-Z])/, "BVCM$<major>"),

        // BV5000 template
        new ObfuscateEntry(/(?<currency>[A-Z]{3})(?<major>\d{6})-(?<minor>\d{3,4})/, "$<currency>-$<major>"),

        // BV1000 template
        new ObfuscateEntry(/B1-(?<currency>[A-Z]{3})-(?<major>\d{6})-(?<minor>\d{3,4})/, "B1-$<currency>-$<major>"),
    ];

    static obfuscate(version: string): string {
        let ret: string = version;
        if (!version) return version;
        this.obfuscateMap.forEach((e: ObfuscateEntry) => {
            if (RegExp(e.regex).exec(version)) {
                ret = version.replace(e.regex, e.replace);
            }
        });
        return ret.trim();
    }
}
